/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dealflowDocChecklistDtoSchema } from "./dealflowDocChecklistDtoSchema.ts";
import { z } from "zod/v4";

export const dealflowCompletenessCheckDtoSchema = z.object({
  get pitchDeck() {
    return dealflowDocChecklistDtoSchema.optional();
  },
  get businessPlan() {
    return dealflowDocChecklistDtoSchema.optional();
  },
  get financialModel() {
    return dealflowDocChecklistDtoSchema.optional();
  },
});
